// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P9-iG","badges":"styles_badges__1Nalw"};